import React from 'react';
import { Package, MapPin } from 'lucide-react';

function DeliveryPointsList({ 
  deliveryPoints, 
  selectedDeliveryPoints, 
  onSelectionChange, 
  onSelectAll, 
  allSelected,
  loading 
}) {
  return (
    <>
      {/* Select All Button */}
      {deliveryPoints.length > 0 && (
        <div className="mb-4">
          <button
            onClick={onSelectAll}
            className="flex items-center gap-2 px-4 py-2 bg-white hover:bg-slate-50 border border-slate-300 rounded-lg transition-colors duration-200 font-montserrat text-sm"
          >
            <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-colors duration-200 ${
              allSelected ? 'bg-[#B1336E] border-[#B1336E]' : 'border-slate-300'
            }`}>
              {allSelected && (
                <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            <span className="text-slate-700 font-medium">
              {allSelected ? 'Deseleccionar todas' : 'Seleccionar todas'}
            </span>
          </button>
        </div>
      )}

      {/* Loading State */}
      {loading && (
        <div className="flex items-center justify-center py-12">
          <div className="w-12 h-12 border-4 border-[#B1336E] border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      {/* Empty State */}
      {!loading && deliveryPoints.length === 0 && (
        <div className="bg-white rounded-2xl border border-slate-200 p-8 text-center">
          <Package className="w-16 h-16 text-slate-300 mx-auto mb-4" />
          <h3 className="text-lg font-bold text-slate-900 font-montserrat mb-2">
            No hay entregas disponibles
          </h3>
          <p className="text-sm text-slate-600 font-montserrat">
            No hay entregas programadas para hoy
          </p>
        </div>
      )}

      {/* Delivery Points List */}
      {!loading && deliveryPoints.length > 0 && (
        <div className="space-y-3">
          {deliveryPoints.map(dp => {
            const isSelected = selectedDeliveryPoints.some(item => item.id === dp.id);
            return (
              <button
                key={dp.id}
                onClick={() => onSelectionChange(dp)}
                className={`w-full bg-white rounded-xl border-2 transition-all duration-200 p-4 text-left ${
                  isSelected 
                    ? 'border-[#B1336E] shadow-md' 
                    : 'border-slate-200 hover:border-slate-300 hover:shadow-sm'
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors duration-200 ${
                    isSelected ? 'bg-[#B1336E] border-[#B1336E]' : 'border-slate-300'
                  }`}>
                    {isSelected && (
                      <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                  </div>

                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                    isSelected ? 'bg-[#B1336E]' : 'bg-slate-100'
                  }`}>
                    <MapPin className={`w-6 h-6 ${isSelected ? 'text-white' : 'text-slate-500'}`} />
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <h3 className="text-base font-bold text-slate-900 font-montserrat truncate">
                        {dp.recipient_name}
                      </h3>
                      <span className="text-xs font-semibold text-slate-500 font-montserrat whitespace-nowrap">
                        ID: {dp.id}
                      </span>
                    </div>
                    <p className="text-sm text-slate-600 font-montserrat line-clamp-1 mb-1">
                      {dp.address}
                    </p>
                    {dp.distric && (
                      <p className="text-xs text-slate-500 font-montserrat">
                        {dp.distric}
                      </p>
                    )}
                    {dp.user_name && (
                      <p className="text-xs text-[#B1336E] font-montserrat font-semibold mt-1">
                        Vendedor: {dp.user_name}
                      </p>
                    )}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}

export default DeliveryPointsList;